import React from 'react';
import { FormattedMessage } from 'react-intl';
import { v1 as uuid } from 'uuid';
import BaseModal from '../../../_shared/components/BaseModal';
import {
  CancelButton,
  StartNegotiationButton,
  StyledTutorialFooter,
  StyledTutorialListItem,
  StyledTutorialNegotiationContainer,
  StyledTutorialNegotiationHeader
} from './Styles';
import { TutorialModalVariant } from '../../../_shared/types/trade';

function TutorialNegotiationModal({
  modalIsOpen,
  onClose,
  onStartNegotiation,
  variant,
  isOmp = false
}) {
  const getMessages = () => {
    switch (variant) {
      case TutorialModalVariant.SELLER_START_NEGO:
        return [
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.message2"
            values={{ b: chunks => <b>{chunks}</b> }}
          />,
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.message0"
            values={{ b: chunks => <b>{chunks}</b> }}
          />,
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.message1"
            values={{ b: chunks => <b>{chunks}</b> }}
          />
        ];
      case TutorialModalVariant.SELLER_START_NEGO_OPEN:
        return [
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.message2"
            values={{ b: chunks => <b>{chunks}</b> }}
          />,
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.open.start.message0"
            values={{ b: chunks => <b>{chunks}</b> }}
          />,
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.message1"
            values={{ b: chunks => <b>{chunks}</b> }}
          />
        ];
      case TutorialModalVariant.SELLER_START_NEGO_DGN:
        return [
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.dgn.message1"
            values={{ b: chunks => <b>{chunks}</b> }}
          />,
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.dgn.message2"
            values={{ b: chunks => <b>{chunks}</b> }}
          />,
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.dgn.message3"
            values={{ b: chunks => <b>{chunks}</b> }}
          />
        ];
      case TutorialModalVariant.SELLER_FIRST_REPLY:
        return [
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.message2"
            values={{ b: chunks => <b>{chunks}</b> }}
          />,
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.message0"
            values={{ b: chunks => <b>{chunks}</b> }}
          />,
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.message1"
            values={{ b: chunks => <b>{chunks}</b> }}
          />
        ];
      case TutorialModalVariant.SELLER_FIRST_REPLY_DGN:
        return [
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.dgn.firstReply.message0"
            values={{ b: chunks => <b>{chunks}</b> }}
          />,
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.dgn.firstReply.message1"
            values={{ b: chunks => <b>{chunks}</b> }}
          />,
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.dgn.message2"
            values={{ b: chunks => <b>{chunks}</b> }}
          />,
          <FormattedMessage
            id="modal.negotiation.tutorial.seller.dgn.message3"
            values={{ b: chunks => <b>{chunks}</b> }}
          />
        ];
      case TutorialModalVariant.BUYER_START_NEGO:
        return [
          <FormattedMessage
            id="modal.negotiation.tutorial.buyer.message0"
            values={{ b: chunks => <b>{chunks}</b> }}
          />,
          <FormattedMessage id="modal.negotiation.tutorial.buyer.message1" />,
          <FormattedMessage
            id="modal.negotiation.tutorial.buyer.message2"
            values={{ b: chunks => <b>{chunks}</b> }}
          />,
          <FormattedMessage
            id="modal.negotiation.tutorial.buyer.message3"
            values={{ b: chunks => <b>{chunks}</b> }}
          />
        ];
      case TutorialModalVariant.BUYER_FIRST_REPLY:
        return [
          <FormattedMessage id="modal.negotiation.tutorial.buyer.message1" />,
          <FormattedMessage
            id="modal.negotiation.tutorial.buyer.message2"
            values={{ b: chunks => <b>{chunks}</b> }}
          />
        ];
      case TutorialModalVariant.SECOND_BIDDER_FINISH_NEGOTIATION:
        return [
          <FormattedMessage id="modal.negotiation.tutorial.buyer.secondBidder.message0" />,
          <FormattedMessage id="modal.negotiation.tutorial.buyer.secondBidder.message1" />,
          <FormattedMessage
            id="modal.negotiation.tutorial.buyer.secondBidder.message2"
            values={{ b: chunks => <b>{chunks}</b> }}
          />
        ];
      default:
        return [];
    }
  };
  const messages = getMessages();

  const getTitleTextId = () => {
    return variant === TutorialModalVariant.SECOND_BIDDER_FINISH_NEGOTIATION
      ? 'vdp.pending.buyer.label.finalAskingPrice'
      : `modal.negotiation.tutorial.title`;
  };

  const getNextButtonTextId = () => {
    return variant === TutorialModalVariant.SECOND_BIDDER_FINISH_NEGOTIATION
      ? 'tiah.continue'
      : 'modal.negotiation.tutorial.negotiation.start';
  };

  return (
    <BaseModal
      isOpen={modalIsOpen}
      isClickEscClose
      isClickOverlayClose
      padding="0px"
      onRequestClose={onClose}
      width={490}
      hasParentSelector={isOmp}
    >
      <StyledTutorialNegotiationContainer>
        <StyledTutorialNegotiationHeader>
          <FormattedMessage id={getTitleTextId()} />
        </StyledTutorialNegotiationHeader>
        {messages.map(message => {
          return (
            <StyledTutorialListItem key={uuid()} data-testid={variant}>
              {message}
            </StyledTutorialListItem>
          );
        })}
        <StyledTutorialFooter>
          <CancelButton onClick={onClose}>
            <FormattedMessage id="modal.cancel" />
          </CancelButton>
          <StartNegotiationButton onClick={onStartNegotiation}>
            <FormattedMessage id={getNextButtonTextId()} />
          </StartNegotiationButton>
        </StyledTutorialFooter>
      </StyledTutorialNegotiationContainer>
    </BaseModal>
  );
}

export default TutorialNegotiationModal;
